import { MutationTree } from 'vuex';
import { UploadingFile } from '@/types';

const mutations: MutationTree<any> = {
  setUploadingFiles(state, files: UploadingFile[]) {
    state.uploadingFiles = files;
  },

  updateUploadingFile(state, uploadingFile) {
    const uploadingFiles = state.uploadingFiles;
    const newUploadingFiles = uploadingFiles.map((file: UploadingFile) => {
      if (file.id === uploadingFile.id) {
        return uploadingFile;
      }
      return file;
    });
    state.uploadingFiles = newUploadingFiles;
  },

  endUploadingFile(state, uploadingFile: UploadingFile) {
    const uploadingFiles = state.uploadingFiles;
    const newUploadingFiles = uploadingFiles.filter((file: UploadingFile) => {
      return file.id !== uploadingFile.id;
    });
    state.uploadingFiles = newUploadingFiles;
  },

  removeUploadingFile(state, uploadingFile: UploadingFile) {
    const uploadingFiles = state.uploadingFiles;

    const newUploadingFiles = uploadingFiles.filter((file: UploadingFile) => {
      return file.id !== uploadingFile.id;
    });
    state.uploadingFiles = newUploadingFiles;
  },
};

export default mutations;
